import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { Title } from '@angular/platform-browser';
import { UserIdleService } from 'angular-user-idle';
import { TranslateService } from "../../../language/translate.service";
import { ItemService } from "./../main/item.service";
import { SaveAuditService } from 'src/app/shared/utils/save-audit.service';
import { TemplateType } from 'src/app/shared/utils/template-type';

@Component({
	selector: "app-home-layout",
	templateUrl: "../main/main.component.html",
	styleUrls: ["../main/main.component.css"]
})
export class HomeLayoutComponent {
	isLoggin: boolean = false;
	clientId: number;
	footerInfo: any;
	language: string = 'vi';
	companyName: string = '';
	address: string = '';
	addressLine2: string = '';
	whatBank: any = {};
	isHidedSign: boolean = false;

	constructor(
		private router: Router,
		public itemService: ItemService,
		private translate: TranslateService,
		private userIdleService: UserIdleService,
		private titleService: Title,
		private saveAuditService: SaveAuditService,
		private templateType: TemplateType,
	) { }

	ngOnInit() {
		this.bank();
		this.saveAuditService.registerAndSaveAuditLog();
		this.getHidedSign();

		this.itemService.getFooterInfo().subscribe(result => {
			this.footerInfo = result.json;
			this.language = this.translate.getcurrentLang();
			this.changeCompanyInfo(this.language);
		});
		this.isLoggin = sessionStorage.getItem("login") == null ? false : true;
		var infoLogin = JSON.parse(sessionStorage.getItem("login"));
		if (infoLogin) {
			this.clientId = infoLogin.clientId;
			this.userIdleService.startWatching();

			this.userIdleService.onTimerStart().subscribe(
				count => console.log('start countdown')
			);
			this.userIdleService.ping$.subscribe(() => 
				console.log("PING")
			);
			this.userIdleService.onTimeout().subscribe(() => 
			{
				console.log('auto Logout');
				this.userIdleService.stopWatching();
				this.DangXuat();
			});
		}
	}

	LogIn() {
		this.router.navigate(["/Login"]);
	}

	DangXuat() {
		if (this.isLoggin) {
			var infoLogin = JSON.parse(sessionStorage.getItem("login"));
			this.saveAuditService.saveAudit({
				functionCode : 'Portal',
				logSummary: 'Portal ' + '[Đăng xuất]',
				logDetail: 'Truy cập menu ' + '[Đăng xuất]',
				userId: infoLogin.userId,
			}, true);

			this.isLoggin = false;
			sessionStorage.removeItem("login");
			sessionStorage.removeItem("UserId");
			this.router.navigate(["/"]);
		}
	}

	customerInformation() {
		this.router.navigate([`/client-management/${this.clientId}/edit`]);
	}
	
	changeCompanyInfo(lang: string) {
		if(lang == 'vi'){
		  this.companyName = this.footerInfo.footerCompanyName;
		  this.address = this.footerInfo.addressStreet;
		  this.addressLine2 = this.footerInfo.addressProvince;
		} else
		{
		  this.companyName = this.footerInfo.footerCompanyNameEN;
		  this.address = this.footerInfo.addressStreetEN;
		  this.addressLine2 = this.footerInfo.addressProvinceEN;
		}
	}
	
	changeTitle(lang: string){
		if(lang == 'vi'){
		  this.titleService.setTitle('Tra cứu hóa đơn');
		} else
		{
		  this.titleService.setTitle('Search invoices');
		}
	  }
	
	changeLanguage(lang) {
		this.translate.use(lang);
		this.changeCompanyInfo(lang);
		this.changeTitle(lang);
	}
	navItemClick() {
		let target: HTMLElement = document.getElementsByClassName(
			"navbar-toggler"
		)[0] as HTMLElement;
		if (target.clientHeight > 0) {
			target.click();
		}
	}

	bank() {
		return this.templateType.whatBank(this.whatBank);
	}

	getHidedSign() {
		this.itemService.getHidedSign().subscribe(result => {
		  this.isHidedSign = JSON.parse(result);
		});
	  }
}
